import React from "react";

import { Button } from "../Button/Button.component";
import { Input } from "../Input/Input.component";
import { CircularProgressbar } from "../CircularProgressbar/CircularProgressbar.component";

import {
  ContinarModal,
  ContainerInputsModal,
} from "./TemplateSendToken.styles";

export interface InputTokensProps {
  "token-1": string;
  "token-2": string;
  "token-3": string;
  "token-4": string;
  "token-5": string;
  "token-6": string;
  error: string;
  loading: boolean;
  disabledSubmit: boolean;
}

interface ModalForgotPasswordProps {
  inputTokens: InputTokensProps;
  countdownRef: any;

  handleSendToken(): void;

  loadingResendToken: boolean;
  handleResendToken(): void;

  setInputToken(name: string, value: string): void;
}

export const TemplateSendToken: React.FC<ModalForgotPasswordProps> = ({
  inputTokens,
  countdownRef,
  handleResendToken,
  handleSendToken,
  loadingResendToken,
  setInputToken,
}) => {
  const handleChangeInputTokens = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { maxLength, value, name } = e.target;
    setInputToken(name, value);

    const [fieldName, fieldIndex] = name.split("-");

    let fieldIntIndex = parseInt(fieldIndex, 10);

    // Check if no of char in field == maxlength
    if (value.length >= maxLength) {
      // It should not be last input field
      if (fieldIntIndex < 6) {
        // Get the next input field using it's name
        const nextfield: any = document.querySelector(
          `input[name=${fieldName}-${fieldIntIndex + 1}]`
        );

        // If found, focus the next field
        if (nextfield !== null) {
          nextfield?.focus();
        }
      }
    } else {
      if (fieldIntIndex > 1) {
        // Get the next input field using it's name
        const nextfield: any = document.querySelector(
          `input[name=${fieldName}-${fieldIntIndex - 1}]`
        );

        // If found, focus the next field
        if (nextfield !== null) {
          nextfield?.focus();
        }
      }
    }
  };

  return (
    <ContinarModal>
      <h4>Digite o código</h4>
      <p>Enviamos um código para o seu celular. </p>

      <ContainerInputsModal>
        <Input
          name="token-1"
          value={inputTokens["token-1"]}
          onChange={handleChangeInputTokens}
          maxLength={1}
          placeholder="0"
          sizeContainer="small"
          type="number"
        />
        <Input
          name="token-2"
          value={inputTokens["token-2"]}
          onChange={handleChangeInputTokens}
          maxLength={1}
          placeholder="0"
          sizeContainer="small"
          type="number"
        />
        <Input
          name="token-3"
          value={inputTokens["token-3"]}
          onChange={handleChangeInputTokens}
          maxLength={1}
          placeholder="0"
          sizeContainer="small"
          type="number"
        />
        <Input
          name="token-4"
          value={inputTokens["token-4"]}
          onChange={handleChangeInputTokens}
          maxLength={1}
          placeholder="0"
          sizeContainer="small"
          type="number"
        />
        <Input
          name="token-5"
          value={inputTokens["token-5"]}
          onChange={handleChangeInputTokens}
          maxLength={1}
          placeholder="0"
          sizeContainer="small"
          type="number"
        />
        <Input
          name="token-6"
          value={inputTokens["token-6"]}
          onChange={handleChangeInputTokens}
          maxLength={1}
          placeholder="0"
          sizeContainer="small"
          type="number"
        />
      </ContainerInputsModal>
      <CircularProgressbar
        message={inputTokens?.error}
        value={120000}
        ref={countdownRef}
      />

      <div className="containerButton">
        <Button
          loading={inputTokens.loading}
          disabled={inputTokens.disabledSubmit}
          onClick={handleSendToken}
        >
          Continuar
        </Button>
        <Button
          variant="text"
          loading={loadingResendToken}
          onClick={handleResendToken}
        >
          Reenviar código
        </Button>
      </div>
    </ContinarModal>
  );
};
